/**
 * BootstrapVue のモーダル名
 */
const MODAL_COMPONENT_NAME = 'BModal'

/**
 * モーダル処理ユーティリティークラス
 */
class ModalUtil {
  /**
   * 指定したコンポーネントの配下で開いているモーダルをすべて閉じる
   *
   * keep-alive で保持されるページは、ページを離れても破棄されない。
   * static ではないモーダルは body 直下に移送されているため、
   * 閉じずに離れると次のページの上に残ったままになる。
   * static のモーダルも、開いたままにすると body の modal-open が残る。
   *
   * モーダルは移送されていても Vue のコンポーネントとしては配下にあるので、
   * DOM ではなくコンポーネントをたどる。
   * @param {Vue} component 起点のコンポーネント
   */
  hideAllIn(component) {
    const hide = (vm) => {
      if (vm.$options.name === MODAL_COMPONENT_NAME) {
        if (vm.isVisible) vm.hide()
        return
      }
      vm.$children.forEach(hide)
    }
    component.$children.forEach(hide)
  }
}

export default new ModalUtil()
